(function(){
  /* swipe gallery + in-place cave switching (separate products, no reload) */
  (function(){
    var track=document.getElementById("gswipeTrack");
    var dotsEl=document.getElementById("gswipeDots");
    var galleryEl=track?track.parentNode:null;
    var CAVES=window.PETINO_CAVES||{};
    function slideW(){return track?track.clientWidth:0;}
    function goTo(i){if(track)track.scrollTo({left:i*slideW(),behavior:"smooth"});}
    function nudge(dir){if(track)track.scrollBy({left:dir*slideW(),behavior:"smooth"});}
    function money(c){return "€"+(c/100).toFixed(2).replace(".",",");}
    function setText(id,v){var e=document.getElementById(id);if(e)e.textContent=(v==null?"":v);}
    function recomputeTiers(price){var box=document.querySelector("[data-bundle]");if(!box)return;
      Array.prototype.forEach.call(box.querySelectorAll(".btier"),function(t){
        var q=parseInt(t.getAttribute("data-qty"),10)||1,d=parseInt(t.getAttribute("data-disc"),10)||0;
        var pe=t.querySelector("[data-bt-price]");if(pe)pe.textContent=money(Math.ceil(price*q*(100-d)/100));});}
    function show(id,on){var e=document.getElementById(id);if(e)e.style.display=on?"":"none";}
    function buildDots(n){if(galleryEl)galleryEl.classList.toggle("is-single",n<=1);
      if(!dotsEl)return;dotsEl.innerHTML="";
      for(var i=0;i<n;i++){(function(idx){var d=document.createElement("span");d.className="gd"+(idx===0?" on":"");
        d.addEventListener("click",function(){goTo(idx);});dotsEl.appendChild(d);})(i);}}
    function buildArrows(){if(!track||!galleryEl||galleryEl.querySelector(".gswipe-arrow"))return;
      function mk(dir){var b=document.createElement("button");b.type="button";
        b.className="gswipe-arrow "+(dir<0?"gswipe-prev":"gswipe-next");
        b.setAttribute("aria-label",dir<0?"Prethodna slika":"Sljedeća slika");
        b.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="'+(dir<0?"M15 5l-7 7 7 7":"M9 5l7 7-7 7")+'" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        b.addEventListener("click",function(){nudge(dir);});return b;}
      galleryEl.appendChild(mk(-1));galleryEl.appendChild(mk(1));}
    function syncDots(){if(!track||!dotsEl||!track.clientWidth)return;var i=Math.round(track.scrollLeft/track.clientWidth);
      Array.prototype.forEach.call(dotsEl.children,function(d,idx){d.classList.toggle("on",idx===i);});}
    if(track)track.addEventListener("scroll",function(){window.requestAnimationFrame(syncDots);},{passive:true});
    function buildGallery(imgs){if(!track)return;track.innerHTML="";
      imgs.forEach(function(src){var sl=document.createElement("div");sl.className="gswipe-slide";
        sl.innerHTML='<img src="'+src+'" width="1024" height="1280" alt="">';track.appendChild(sl);});
      track.scrollLeft=0;buildDots(imgs.length);}
    if(track){buildArrows();buildDots(track.querySelectorAll(".gswipe-slide").length);}
    function applyDiscount(prod){
      var pp=document.getElementById("pPrice");
      if(prod.cmp&&prod.cmp>prod.price){
        var was=document.getElementById("pWas");if(was){was.textContent=money(prod.cmp);was.style.display="";}
        var sv=document.getElementById("pSave");if(sv){sv.textContent="−"+Math.round((prod.cmp-prod.price)*100/prod.cmp)+"%";sv.style.display="";}
        var sa=document.getElementById("pSavingAmt");if(sa)sa.textContent=Math.round((prod.cmp-prod.price)/100);
        show("pSaving",true);
        if(pp)pp.classList.add("price--sale");
      }else{show("pWas",false);show("pSave",false);show("pSaving",false);if(pp)pp.classList.remove("price--sale");}
    }
    var curBase=0,curName="";
    function selectTier(t){var box=document.querySelector("[data-bundle]");if(!box||!t)return;
      Array.prototype.forEach.call(box.querySelectorAll(".btier"),function(x){x.classList.remove("is-on");});
      t.classList.add("is-on");
      var q=parseInt(t.getAttribute("data-qty"),10)||1,d=parseInt(t.getAttribute("data-disc"),10)||0;
      var qi=document.querySelector("[data-qty-input]");if(qi)qi.value=q;
      Array.prototype.forEach.call(document.querySelectorAll("[data-sticky-qty]"),function(i){i.value=q;});
      var total=Math.ceil(curBase*q*(100-d)/100);
      var sp=document.getElementById("sPrice");if(sp)sp.textContent=money(total);
      var sn=document.getElementById("sName");if(sn)sn.textContent=(q>1?q+" \u00d7 "+curName:curName);}
    function apply(h,prod){
      var c=CAVES[h]||{};
      buildGallery(prod.images||[]);
      setText("pName",prod.title);setText("pDesc",c.desc);setText("pPrice",money(prod.price));setText("pTone",c.tone);
      recomputeTiers(prod.price);
      applyDiscount(prod);
      setText("sName",prod.title);setText("sPrice",money(prod.price));
      curBase=prod.price;curName=prod.title;
      var _bt1=document.querySelector('[data-bundle] .btier[data-qty="1"]');if(_bt1)selectTier(_bt1);
      var sDot=document.getElementById("sDot");if(sDot)sDot.className="sc-dot dot "+(c.sw||"");
      var vid=prod.vid||"";
      Array.prototype.forEach.call(document.querySelectorAll('form input[name="id"]'),function(inp){inp.value=vid;});
      if(c.hex)document.documentElement.style.setProperty("--accent-tone",c.hex);
      if(c.bg)document.documentElement.style.setProperty("--accent-bg",c.bg);
      Array.prototype.forEach.call(document.querySelectorAll(".swatch[data-cave]"),function(x){x.classList.toggle("active",x.getAttribute("data-cave")===h);});
      Array.prototype.forEach.call(document.querySelectorAll(".retreat[data-cave]"),function(x){x.classList.toggle("active",x.getAttribute("data-cave")===h);});
      try{history.pushState({},"","/products/"+h);}catch(e){}
      if(prod.title)document.title=prod.title+" — Petino";
    }
    function select(h,opts){var prod=CAVES[h];if(!prod)return;apply(h,prod);
      if(opts&&opts.scroll){var p=document.querySelector(".pdp");if(p)p.scrollIntoView({behavior:"smooth",block:"start"});}}
    Array.prototype.forEach.call(document.querySelectorAll(".swatch[data-cave]"),function(sw){
      sw.addEventListener("click",function(ev){ev.preventDefault();select(sw.getAttribute("data-cave"));});});
    Array.prototype.forEach.call(document.querySelectorAll(".retreat[data-cave]"),function(rt){
      rt.addEventListener("click",function(ev){ev.preventDefault();select(rt.getAttribute("data-cave"),{scroll:true});});});
    (function(){var box=document.querySelector("[data-bundle]");if(!box)return;
      var base=parseInt(box.getAttribute("data-base-price"),10)||0;curBase=base;
      curName=(document.getElementById("pName")||{}).textContent||"";recomputeTiers(base);
      Array.prototype.forEach.call(box.querySelectorAll(".btier"),function(t){
        t.addEventListener("click",function(){selectTier(t);});});})();
  })();

  /* apparel size picker — sets the chosen variant on every ATC form + sticky */
  (function(){
    var box=document.querySelector("[data-size-pick]");if(!box)return;
    function money(c){return "€"+(c/100).toFixed(2).replace(".",",");}
    function pick(btn){
      if(!btn||btn.disabled)return;
      Array.prototype.forEach.call(box.querySelectorAll(".size-opt"),function(b){b.classList.remove("is-on");b.setAttribute("aria-pressed","false");});
      btn.classList.add("is-on");btn.setAttribute("aria-pressed","true");
      var vid=btn.getAttribute("data-vid")||"";
      var cur=box.querySelector("[data-size-current]");if(cur)cur.textContent=btn.getAttribute("data-title")||"";
      Array.prototype.forEach.call(document.querySelectorAll('form input[name="id"]'),function(inp){inp.value=vid;});
      var price=parseInt(btn.getAttribute("data-price"),10);
      if(price){var sp=document.getElementById("sPrice");if(sp)sp.textContent=money(price);}
    }
    Array.prototype.forEach.call(box.querySelectorAll(".size-opt"),function(b){
      b.addEventListener("click",function(){pick(b);});});
  })();

  /* scroll-reveal */
  (function(){
    var items=document.querySelectorAll("[data-rise]");if(!items.length)return;
    var reduce=window.matchMedia("(prefers-reduced-motion:reduce)").matches;
    if(reduce||!("IntersectionObserver" in window)){Array.prototype.forEach.call(items,function(el){el.classList.add("in");});return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target);}});
    },{rootMargin:"0px 0px -8% 0px",threshold:.08});
    Array.prototype.forEach.call(items,function(el){io.observe(el);});
    setTimeout(function(){Array.prototype.forEach.call(items,function(el){el.classList.add("in");});},900);
  })();

  /* review carousel arrows */
  (function(){var rail=document.querySelector(".review-rail");if(!rail)return;
    function step(d){var c=rail.querySelector(".review");var w=c?c.offsetWidth+16:300;rail.scrollBy({left:d*w,behavior:"smooth"});}
    var pv=document.querySelector(".rail-prev"),nx=document.querySelector(".rail-next");
    if(pv)pv.addEventListener("click",function(){step(-1);});
    if(nx)nx.addEventListener("click",function(){step(1);});})();
  /* interactive comparison tabs */
  (function(){var tabs=document.querySelectorAll(".cmp2-tab");if(!tabs.length)return;
    var D=window.PETINO_CMP||[],syn=document.getElementById("cmpSyn"),wool=document.getElementById("cmpWool");
    function fade(el){if(!el)return;el.style.animation="none";void el.offsetWidth;el.style.animation="cmpfade .3s ease";}
    function pick(i){var d=D[i]||{};if(syn){syn.textContent=d.s||"";fade(syn);}if(wool){wool.textContent=d.w||"";fade(wool);}
      Array.prototype.forEach.call(tabs,function(t){t.classList.toggle("is-on",t.getAttribute("data-asp")===String(i));});}
    Array.prototype.forEach.call(tabs,function(t){t.addEventListener("click",function(){pick(parseInt(t.getAttribute("data-asp"),10));});});})();
  /* interactive summer toggle */
  (function(){var tabs=document.querySelectorAll(".season-tab");if(!tabs.length)return;
    var D=window.PETINO_SEASON||[],txt=document.getElementById("seasonText"),panel=document.getElementById("seasonPanel");
    function pick(i){var d=D[i]||{};if(txt){txt.textContent=d.t||"";txt.style.animation="none";void txt.offsetWidth;txt.style.animation="cmpfade .3s ease";}
      if(panel)panel.setAttribute("data-mode",String(i));
      Array.prototype.forEach.call(tabs,function(t){t.classList.toggle("is-on",t.getAttribute("data-s")===String(i));});}
    Array.prototype.forEach.call(tabs,function(t){t.addEventListener("click",function(){pick(parseInt(t.getAttribute("data-s"),10));});});})();
  /* sticky mobile cart — reveal once the in-page CTA scrolls out of view */
  (function(){
    var bar=document.querySelector(".sticky-cart");var anchor=document.querySelector(".panel .cart-btn");
    if(!bar||!anchor)return;
    if(!("IntersectionObserver" in window)){bar.classList.add("is-visible");return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){bar.classList.toggle("is-visible",!e.isIntersecting);});
    },{threshold:0});
    io.observe(anchor);
  })();

  /* real reviews — fill the grid from the bundled JSON (data, not markup) */
  (function(){
    var grid=document.getElementById("petino-review-grid");if(!grid)return;
    var url=grid.getAttribute("data-reviews");if(!url)return;
    function esc(t){var d=document.createElement("div");d.textContent=t||"";return d.innerHTML;}
    fetch(url).then(function(r){return r.json();}).then(function(d){
      (d.reviews||[]).forEach(function(rv){
        var n=rv.rating||5,st="";for(var i=0;i<n;i++)st+='<svg viewBox="0 0 24 24"><path d="M12 2.6l2.65 5.37 5.93.86-4.29 4.18 1.01 5.9L12 18.1l-5.3 2.79 1.01-5.9-4.29-4.18 5.93-.86z"/></svg>';
        var who="<b>"+esc(rv.name)+"</b>"+(rv.city?" · "+esc(rv.city):"");
        var tr=rv.translated?'<p class="petino-review-translated" style="font-size:12px;color:var(--muted);margin-top:10px">Prevedeno.</p>':"";
        var el=document.createElement("div");el.className="review";
        el.innerHTML='<div class="stars" aria-label="'+n+'/5">'+st+'</div><p>'+esc(rv.body)+'</p><div class="who">'+who+'</div>'+tr;
        grid.appendChild(el);
      });
    }).catch(function(){});
  })();

  /* premium: topbar shadow on scroll */
  (function(){var tb=document.querySelector(".topbar");if(!tb)return;
    var on=function(){tb.classList.toggle("scrolled",(window.scrollY||document.documentElement.scrollTop)>12);};
    on();window.addEventListener("scroll",on,{passive:true});})();

  /* premium: count-up the verified-customers stat on reveal */
  (function(){
    var els=document.querySelectorAll(".petino-countup");if(!els.length)return;
    if(!("IntersectionObserver" in window)||window.matchMedia("(prefers-reduced-motion:reduce)").matches)return;
    var io=new IntersectionObserver(function(en){en.forEach(function(e){
      if(!e.isIntersecting)return;io.unobserve(e.target);
      var el=e.target,target=parseInt(el.getAttribute("data-count"),10)||0,t0=null,dur=1300;
      function step(ts){if(!t0)t0=ts;var p=Math.min((ts-t0)/dur,1),ease=1-Math.pow(1-p,3);
        el.textContent=Math.round(ease*target);if(p<1)requestAnimationFrame(step);else el.textContent=target;}
      requestAnimationFrame(step);
    });},{threshold:.4});
    Array.prototype.forEach.call(els,function(el){io.observe(el);});
  })();

  /* cart drawer — AJAX add, slide-in, remove, free-ship progress */
  (function(){
    var drawer=document.querySelector("[data-cart-drawer]"), overlay=document.querySelector("[data-cart-overlay]");
    function money(c){return "€"+(c/100).toFixed(2).replace(".",",");}
    function openD(){if(drawer){drawer.classList.add("open");drawer.setAttribute("aria-hidden","false");}if(overlay)overlay.classList.add("open");document.body.style.overflow="hidden";}
    function closeD(){if(drawer){drawer.classList.remove("open");drawer.setAttribute("aria-hidden","true");}if(overlay)overlay.classList.remove("open");document.body.style.overflow="";}
    var FREE=8000;
    function renderShip(total){var el=drawer&&drawer.querySelector("[data-cart-ship]");if(!el)return;
      if(total>=FREE){el.innerHTML="✓ Besplatna dostava je otključana.";}
      else{var pct=Math.min(100,Math.round(total*100/FREE));el.innerHTML="Još <b>"+money(FREE-total)+"</b> do besplatne dostave<div class=\"pcart-bar\"><i style=\"width:"+pct+"%\"></i></div>";}}
    function sized(u){return u?u.replace(/(\.[a-zA-Z]+)(\?|$)/,"_160x$1$2"):"";}
    function renderCart(c){
      var items=drawer&&drawer.querySelector("[data-cart-items]");
      if(items){items.innerHTML="";(c.items||[]).forEach(function(it){
        var li=document.createElement("li");li.className="pcart-item";li.setAttribute("data-key",it.key);
        li.innerHTML='<img src="'+sized(it.image)+'" width="60" height="75" alt="">'
          +'<div class="pci"><div class="pci-t">'+it.product_title+'</div>'
          +'<div class="pci-r"><span data-line-qty>'+it.quantity+'</span> × '+money(it.final_price)+'</div>'
          +'<button class="pci-rm" data-cart-remove>Ukloni</button></div>';
        items.appendChild(li);});}
      Array.prototype.forEach.call(document.querySelectorAll("[data-cart-subtotal]"),function(e){e.textContent=money(c.total_price);});
      Array.prototype.forEach.call(document.querySelectorAll("[data-cart-count]"),function(e){e.textContent=c.item_count;});
      var empty=drawer&&drawer.querySelector("[data-cart-empty]"),foot=drawer&&drawer.querySelector("[data-cart-foot]");
      if(empty)empty.hidden=c.item_count>0; if(foot)foot.hidden=c.item_count===0;
      renderShip(c.total_price);
    }
    function refresh(cb){fetch("/cart.js",{headers:{"Accept":"application/json"}}).then(function(r){return r.json();}).then(function(c){renderCart(c);if(cb)cb(c);}).catch(function(){});}
    Array.prototype.forEach.call(document.querySelectorAll('form[action*="/cart/add"]'),function(form){
      form.addEventListener("submit",function(ev){ev.preventDefault();var fd=new FormData(form);
        fetch("/cart/add.js",{method:"POST",body:fd,headers:{"Accept":"application/json"}})
          .then(function(r){return r.json();}).then(function(){refresh(openD);}).catch(function(){form.submit();});});});
    document.addEventListener("click",function(ev){
      var t=ev.target;
      var rm=t.closest&&t.closest("[data-cart-remove]");
      if(rm){ev.preventDefault();var li=rm.closest("[data-key]");if(!li)return;
        fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({id:li.getAttribute("data-key"),quantity:0})})
          .then(function(r){return r.json();}).then(function(c){renderCart(c);}).catch(function(){});return;}
      var op=t.closest&&t.closest("[data-cart-open]");if(op){ev.preventDefault();refresh(openD);return;}
      if(t.closest&&t.closest("[data-cart-close]")){closeD();return;}
      if(t.hasAttribute&&t.hasAttribute("data-cart-overlay")){closeD();return;}
    });
    refresh();
  })();
})();
